export default class Button {

  constructor(element) {
    this.element = element;
  }

  get id() {
    return +this.element.attr('data-item');
  }

  revert() {
    console.log('revert', this.element);
    this.element.data('dropped', false);
    this.element.animate(
    	this.element.data("uiDraggable").originalPosition, 
    	"slow"
    );
  }

  moveToElement(leafElement) {
    let $leafElement = $(leafElement);

    this.element.position({
      my: 'left top',
      at: 'center',
      of: $leafElement,
      using: function (position) {
        $(this).animate(position, 'slow', 'linear');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/button.view.js